import {
  Checkbox,
  FormControlLabel,
  Popover,
  List,
  ListItem
} from '@material-ui/core';
import { Columns3 } from 'lucide-react';
import React, { useState } from 'react';
import { useThemeContext } from 'shared/context/themeContext';
import { dark as darkColors, light as lightColors } from 'shared/theme/colorTokens';

interface ColumnSelectorProps {
  columns: any;
  onChange: (columns: any) => void;
  columnLabels: any;
}

export const ColumnSelector: React.FC<ColumnSelectorProps> = ({
  columns,
  onChange,
  columnLabels
}) => {
  const { theme } = useThemeContext();
  const isDark = theme === 'dark';
  const colors = isDark ? darkColors : lightColors;
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleToggle = (columnName: keyof any) => {
    onChange({
      ...columns,
      [columnName]: !columns[columnName]
    });
  };

  return (
    <>
      <button
        type="button"
        title="Columnas visibles"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        className="inline-flex h-9 w-9 items-center justify-center rounded-full text-inkMuted transition hover:scale-110 hover:text-secondary-600 dark:text-inkMuted-dark dark:hover:text-secondary-300"
      >
        <Columns3 size={18} />
      </button>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        PaperProps={{
          style: {
            backgroundColor: colors.surface,
            borderRadius: 12
          }
        }}
      >
        <div className="p-4" style={{ maxWidth: '300px' }}>
          <p
            className="mb-2 text-xs font-medium uppercase tracking-wide text-inkMuted dark:text-inkMuted-dark"
          >
            Columnas visibles
          </p>
          <List dense>
            {(Object.keys(columns) as Array<keyof any>).map((columnKey) => (
              <ListItem key={columnKey as string} disableGutters>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={columns[columnKey]}
                      onChange={() => handleToggle(columnKey)}
                      size="small"
                      style={{ color: colors.accent }}
                    />
                  }
                  label={columnLabels[columnKey]}
                  style={{ color: colors.textPrimary }}
                />
              </ListItem>
            ))}
          </List>
        </div>
      </Popover>
    </>
  );
};

export default ColumnSelector;
